import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "table" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 0,
  class: "badge text-bg-danger fw-medium"
}
const _hoisted_10 = {
  key: 1,
  class: "badge text-bg-success fw-medium"
}
const _hoisted_11 = {
  key: 0,
  class: "badge text-bg-danger fw-medium"
}
const _hoisted_12 = {
  key: 1,
  class: "badge text-bg-success fw-medium"
}
const _hoisted_13 = { colspan: "3" }
const _hoisted_14 = {
  class: "modal fade createNewModal",
  id: "RejetCessionModal",
  tabindex: "-1",
  ref: "addDemandeModalRef",
  "aria-hidden": "true"
}
const _hoisted_15 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_16 = { class: "modal-content p-15 p-md-40" }
const _hoisted_17 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md-12" }
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[20] || (_cache[20] = _createElementVNode("h4", { class: "text-black fw-bold mb-10" }, "Informations de l'abonnement", -1)),
            _createElementVNode("table", _hoisted_5, [
              _createElementVNode("tbody", null, [
                (_ctx.abonnement)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                      _cache[1] || (_cache[1] = _createElementVNode("td", null, [
                        _createElementVNode("b", null, "ABONNEMENT")
                      ], -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.refAbo), 1),
                      _cache[2] || (_cache[2] = _createElementVNode("td", null, [
                        _createElementVNode("b", null, "DEMANDEUR")
                      ], -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.abonne?.nomComplet), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.abonnement?.adresseVirtuelle)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                      _cache[3] || (_cache[3] = _createElementVNode("td", null, [
                        _createElementVNode("b", null, "Adresse virtuelle")
                      ], -1)),
                      _createElementVNode("td", null, _toDisplayString((_ctx.abonnement?.adresseVirtuelle) ? _ctx.abonnement?.adresseVirtuelle : ''), 1),
                      _cache[4] || (_cache[4] = _createElementVNode("td", null, [
                        _createElementVNode("b", null, "Adresse postale")
                      ], -1)),
                      _createElementVNode("td", null, _toDisplayString((_ctx.abonnement?.boite?.adressePostale) ? _ctx.abonnement?.boite?.adressePostale.adresse_postale : ''), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("tr", null, [
                  _cache[5] || (_cache[5] = _createElementVNode("td", null, [
                    _createElementVNode("b", null, "Modele de boite")
                  ], -1)),
                  _createElementVNode("td", null, _toDisplayString((_ctx.abonnement?.boite) ? _ctx.abonnement?.boite?.modele?.libelle : ''), 1),
                  _cache[6] || (_cache[6] = _createElementVNode("td", null, [
                    _createElementVNode("b", null, "Boite postale")
                  ], -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.boite?.refBoite), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[7] || (_cache[7] = _createElementVNode("td", null, [
                    _createElementVNode("b", null, "Tarif")
                  ], -1)),
                  _createElementVNode("td", null, _toDisplayString((_ctx.abonnement?.loyer) ? _ctx.abonnement?.loyer + " F CFA" : ''), 1),
                  _cache[8] || (_cache[8] = _createElementVNode("td", null, [
                    _createElementVNode("b", null, "Caution")
                  ], -1)),
                  _createElementVNode("td", null, _toDisplayString((_ctx.abonnement) ? _ctx.abonnement?.caution : ''), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[9] || (_cache[9] = _createElementVNode("td", null, [
                    _createElementVNode("b", null, "Date d'abonnement")
                  ], -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.format_date(_ctx.abonnement?.dateAbonnement)), 1),
                  _cache[10] || (_cache[10] = _createElementVNode("td", null, null, -1)),
                  _cache[11] || (_cache[11] = _createElementVNode("td", null, null, -1))
                ]),
                (_ctx.abonnement)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                      _cache[12] || (_cache[12] = _createElementVNode("td", null, [
                        _createElementVNode("b", null, "Etat abonnement")
                      ], -1)),
                      _createElementVNode("td", null, [
                        (_ctx.abonnement.estResilier)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Inactif "))
                          : (_openBlock(), _createElementBlock("span", _hoisted_10, "Actif"))
                      ]),
                      _cache[13] || (_cache[13] = _createElementVNode("td", null, "Arrierés", -1)),
                      _createElementVNode("td", null, [
                        (_ctx.totaleArr.arrires > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.totaleArr.arrires? (_ctx.totaleArr.arrires+ " F CFA") : 0 + " F CFA"), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.totaleArr.arrires? _ctx.totaleArr.arrires : 0 + " F CFA"), 1))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("tr", null, [
                  _cache[14] || (_cache[14] = _createElementVNode("td", null, [
                    _createElementVNode("b", null, " Contenu")
                  ], -1)),
                  _createElementVNode("td", _hoisted_13, _toDisplayString((_ctx.demande) ? _ctx.demande.contenu : ''), 1)
                ]),
                _cache[17] || (_cache[17] = _createElementVNode("tr", null, null, -1)),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, [
                    (_ctx.demande?.status !== 'Validée')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-success",
                          href: "javascript:void(0);",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.accept(_ctx.demande)))
                        }, " Suivant "))
                      : _createCommentVNode("", true)
                  ]),
                  _cache[15] || (_cache[15] = _createElementVNode("td", null, null, -1)),
                  _cache[16] || (_cache[16] = _createElementVNode("td", null, null, -1))
                ])
              ]),
              _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
              _cache[19] || (_cache[19] = _createElementVNode("tfoot", null, null, -1))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }, [
            _createElementVNode("h5", { class: "modal-title fw-bold text-black" }, "Rejet d'une demande")
          ], -1)),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_Form, {
              ref: "rejetCessionForm",
              onSubmit: _ctx.rejectResiliation,
              "validation-schema": _ctx.rejetCessionFormSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                        _createTextVNode(" Motif "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "motif",
                        type: "textarea",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Entrer une adresse"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "motif",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _cache[22] || (_cache[22] = _createElementVNode("button", {
                    class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
                    type: "submit"
                  }, " Confirmer le rejet ", -1))
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ]),
          _cache[24] || (_cache[24] = _createElementVNode("button", {
            type: "button",
            class: "btn-close shadow-none",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1))
        ])
      ])
    ], 512)
  ], 64))
}